import { render, staticRenderFns } from "./job-detail.vue?vue&type=template&id=b5fdf3fe&scoped=true&"
import script from "./job-detail.vue?vue&type=script&lang=js&"
export * from "./job-detail.vue?vue&type=script&lang=js&"
import style0 from "./job-detail.vue?vue&type=style&index=0&id=b5fdf3fe&lanng=scss&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fdf3fe",
  null
  
)

export default component.exports